import React from 'react';
import { Grid, Typography, Card, CardHeader, CardContent } from '@mui/material';
import { useApiGet } from '../../../utils/httpClientTs';
import { getIntlBoard } from '../../../endpoints/chapters';
import PositionDisplay from '../../../Components/PositionDisplay';

interface BoardMember {
  id: string;
  position: string;
  position_id: string;
  committee_id: string;
  name: string;
  start_date: string;
  end_date: string | null;
  user_id: string;
  order: number;
}

interface BoardData {
  name: string;
  description: string;
  members: BoardMember[];
}

const IntlBoard: React.FC = () => {
  const { data: boardData, isFetching } = useApiGet<BoardData>(
    ['intl-board'],
    getIntlBoard,
    {
      enabled: true,
      retry: 1,
    },
    {}
  );

  if (isFetching) {
    return (
      <Grid item xs={12} textAlign={'center'} paddingTop={2}>
        <Typography variant="body1">Loading...</Typography>
      </Grid>
    );
  }

  if (!boardData) {
    return (
      <Grid item xs={12} textAlign={'center'} paddingTop={2}>
        <Typography variant="body1">No data available</Typography>
      </Grid>
    );
  }

  return (
    <Grid container>
      <Grid item xs={12} sx={{ padding: 2 }}>
        <Card sx={{ p: 2, boxShadow: 3, borderRadius: 2 }}>
          <CardHeader
            title={boardData.name}
            subheader={boardData.description}
            sx={{ p: 1 }}
          />
          <CardContent sx={{ p: 1 }}>
            <Grid container spacing={2}>
              {boardData.members
                .sort((a, b) => a.order - b.order)
                .map((user) => (
                  <PositionDisplay
                    id={user.id}
                    position={user.position}
                    positionId={user.position_id}
                    committeeId={user.committee_id}
                    name={user.name}
                    startDate={user.start_date}
                    endDate={user.end_date}
                    canEdit={false}
                    isSaving={false}
                    errorSavingText={null}
                    onSave={null}
                    userId={user.user_id}
                    key={user.id}
                    pageFrom={'intl-board'}
                    canMessage={true}
                  />
                ))}
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default IntlBoard;
